import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

const Quiz = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = 6;
  const [quizData, setQuizData] = useState({
   typeGroup: '',
    recipient: '',
    recipientOther: '',
    personName: '',
    eventType: '',
    eventOther: '',
    eventNames: '',
    style: '',
    styleOther: '',
    voice: '',
    qualities: '',
    memories: '',
    yourName: '',
    email: '',
    phone: '',
    package: ''
  });

  const location = useLocation();


  const [counters, setCounters] = useState({
    personName: 0,
    qualities: 0,
    memories: 0,
    recipient: '',
    recipientOther: '',
    eventType: '',
    eventOther: '',
    eventNames: '',
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setQuizData(prev => ({ ...prev, [id]: value }));
    if (counters.hasOwnProperty(id)) {
      setCounters(prev => ({ ...prev, [id]: value.length }));
    }
  };

  const handleOptionSelect = (field, value) => {
    setQuizData(prev => ({ ...prev, [field]: value }));
  };


  const validateStep = () => {
    // PASSO 0 – Tipo (Pessoa ou Evento)
    if (currentStep === 0) {
      if (!quizData.typeGroup) {
        alert('Selecione se a música é para uma pessoa ou um evento');
        return false;
      }
    }

    // PASSO 1 – Pessoa ou Evento
    else if (currentStep === 1) {

      // ===== PESSOA =====
      if (quizData.typeGroup === 'pessoa') {
        if (!quizData.recipient) {
          alert('Selecione para quem é a música');
          return false;
        }

        if (quizData.recipient === 'other' && !quizData.recipientOther) {
          alert('Informe o parentesco');
          return false;
        }

        if (!quizData.personName) {
          alert('Digite o nome da pessoa');
          return false;
        }
      }

      // ===== EVENTO =====
      if (quizData.typeGroup === 'evento') {
        if (!quizData.eventType) {
          alert('Selecione o tipo de evento');
          return false;
        }

        if (quizData.eventType === 'other' && !quizData.eventOther) {
          alert('Informe o tipo do evento');
          return false;
        }

        {/*if (!quizData.eventName) {
          alert('Digite o nome do evento');
          return false;
        }*/}
      }
    }

    // PASSO 2 – Estilo / Voz
    else if (currentStep === 2) {
      if (!quizData.style) {
        alert('Selecione um estilo musical');
        return false;
      }

      if (quizData.style === 'other' && !quizData.styleOther) {
        alert('Informe o estilo musical');
        return false;
      }

      if (!quizData.voice) {
        alert('Selecione a preferência de voz');
        return false;
      }
    }

    // PASSO 5 – Dados finais
    else if (currentStep === 5) {
      if (
        !quizData.yourName?.trim() ||
        !quizData.email?.trim() ||
        !quizData.phone?.trim()
      ) {
        alert('Por favor, preencha todos os campos obrigatórios');
        return false;
      }
    }

    return true;
  };


  const nextStep = () => {
    if (!validateStep()) return;
    if (currentStep < totalSteps) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
      window.scrollTo(0, 0);
    }
  };

  const submitQuiz = () => {
    if (!validateStep()) return;
    sessionStorage.setItem('quizData', JSON.stringify(quizData));
    // navigate('/checkout');

    // Lê o package atual da URL do quiz
    const params = new URLSearchParams(location.search);
    const selectedPackage = params.get('package') || '24h';

    // Navega para o checkout mantendo a flag
    navigate(`/checkout?package=${selectedPackage}`);
  };
  

  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div className="quiz-page-wrapper">
      <style>{`
        .quiz-page-wrapper {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #111827;
          background: linear-gradient(135deg, #f3f4f6 0%, #ffffff 100%);
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }

        .quiz-container {
          background: white;
          border-radius: 1.5rem;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          width: 100%;
          max-width: 700px;
          padding: 3rem 2rem;
        }

        .quiz-header {
          margin-bottom: 2rem;
          text-align: center;
        }

        .quiz-logo {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        .progress-container {
          margin-bottom: 2rem;
        }

        .progress-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .progress-text {
          font-size: 0.95rem;
          font-weight: 600;
          color: #111827;
        }

        .progress-percentage {
          font-size: 0.95rem;
          font-weight: 700;
          color: #F59E0B;
        }

        .progress-bar {
          width: 100%;
          height: 8px;
          background: #E5E7EB;
          border-radius: 10px;
          overflow: hidden;
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #8B5CF6, #EC4899);
          border-radius: 10px;
          transition: width 0.3s ease;
        }

        .step-section {
          display: none;
          animation: fadeIn 0.5s ease-in-out;
        }

        .step-section.active {
          display: block;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .step-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #111827;
        }

        .step-description {
          font-size: 0.95rem;
          color: #6B7280;
          margin-bottom: 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-label {
          display: block;
          font-weight: 600;
          margin-bottom: 0.75rem;
          color: #111827;
          font-size: 1rem;
        }

        .form-label .required {
          color: #EF4444;
        }

        .hint-text {
          font-size: 0.85rem;
          color: #6B7280;
          margin-top: 0.25rem;
        }

        .button-group {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 1rem;
        }

        .option-btn {
          padding: 1rem;
          border: 2px solid #D1D5DB;
          background: white;
          border-radius: 0.75rem;
          cursor: pointer;
          transition: all 0.3s ease;
          font-weight: 600;
          font-size: 0.95rem;
          text-align: center;
          color: #111827;
        }

        .option-btn:hover {
          border-color: #8B5CF6;
          background: rgba(139, 92, 246, 0.05);
        }

        .option-btn.selected {
          background: #8B5CF6;
          color: white;
          border-color: #8B5CF6;
        }

        .form-input, .form-textarea, .form-select {
          width: 100%;
          padding: 0.85rem 1rem;
          border: 2px solid #D1D5DB;
          border-radius: 0.75rem;
          font-size: 1rem;
          font-family: inherit;
          transition: border-color 0.3s ease;
          color: #111827;
        }

        .form-input:focus, .form-textarea:focus, .form-select:focus {
          outline: none;
          border-color: #8B5CF6;
          box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
        }

        .char-counter {
          font-size: 0.8rem;
          color: #6B7280;
          margin-top: 0.25rem;
          text-align: right;
        }

        .button-group-nav {
          display: flex;
          gap: 1rem;
          margin-top: 3rem;
          justify-content: space-between;
        }

        .btn {
          padding: 1rem 2rem;
          border-radius: 0.75rem;
          border: none;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 1rem;
        }

        .btn-back { background: #F3F4F6; color: #111827; flex: 0.4; }
        .btn-back:hover { background: #E5E7EB; }
        .btn-next { background: #8B5CF6; color: white; flex: 1; }
        .btn-next:hover { background: #7C3AED; transform: translateY(-2px); box-shadow: 0 10px 25px rgba(139, 92, 246, 0.3); }
        .btn-finish { background: linear-gradient(135deg, #8B5CF6, #EC4899); color: white; flex: 1; }
        .btn-finish:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(139, 92, 246, 0.4); }

        @media (max-width: 600px) {
          .quiz-container { padding: 2rem 1.5rem; }
          .button-group-nav { flex-direction: column; }
          .btn-back, .btn-next, .btn-finish { flex: 1; width: 100%; }
        }

        .text-input {
        width: 100%;
        padding: 12px 14px;
        font-size: 1rem;
        border-radius: 12px;
        border: 2px solid #e0e0e0;
        background-color: #fafafa;
        transition: all 0.25s ease;
        outline: none;
        margin-top: 8px;
        }

        .text-input:focus {
        border-color: #6c63ff;         
        background-color: #ffffff;
        box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.15);
        }

        .text-input::placeholder {
        color: #999;
        }

        .extra-field {
        margin-top: 16px;
        }
      `}</style>

      <div className="quiz-container">
        <div className="quiz-header">
          <Link to="/" style={{ textDecoration: 'none', color: '#6B7280', fontSize: '0.9rem', display: 'block', marginBottom: '1rem' }}>← Voltar para a Home</Link>
          <div className="quiz-logo">🎵 Cantando Vidas</div>
        </div>

        <div className="progress-container">
          <div className="progress-info">
            <span className="progress-text">Passo {currentStep} de {totalSteps}</span>
            <span className="progress-percentage">{Math.round(percentage)}% Completo</span>
          </div>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${percentage}%` }}></div>
          </div>
        </div>
        
        {/* Passo 0: Tipo */}
        <div className={`step-section ${currentStep === 0 ? 'active' : ''}`}>
          <h2 className="step-title">Qual o objetivo da música?</h2>
          <p className="step-description">
            Selecione se a música é para uma pessoa ou um evento.
          </p>

          <div className="button-group">
            <button
              type="button"
              className={`option-btn ${
                quizData.typeGroup === 'pessoa' ? 'selected' : ''
              }`}
              onClick={() => handleOptionSelect('typeGroup', 'pessoa')}
            >
              Para uma Pessoa
            </button>

            <button
              type="button"
              className={`option-btn ${
                quizData.typeGroup === 'evento' ? 'selected' : ''
              }`}
              onClick={() => handleOptionSelect('typeGroup', 'evento')}
            >
              Para um Evento
            </button>
          </div>

          <div className="button-group-nav">
            <button
              type="button"
              className="btn btn-next"
              onClick={nextStep}
              disabled={!quizData.typeGroup}
            >
              Próximo →
            </button>
          </div>
        </div>
        
        {/* Passo 1: Pessoa */}
        {currentStep === 1 && quizData.typeGroup === 'pessoa' && (
          <div className="step-section active">
            <h2 className="step-title">Para quem é a música?</h2>
            <p className="step-description">Conte-nos quem será o homenageado.</p>

            <div className="form-group">
              <label className="form-label">
                A música é para: <span className="required">*</span>
              </label>

              <div className="button-group">
                {[
                  { value: 'spouse', label: 'Esposo' },
                  { value: 'wife', label: 'Esposa' },
                  { value: 'son', label: 'Filho' },
                  { value: 'daughter', label: 'Filha' },
                  { value: 'father', label: 'Pai' },
                  { value: 'mother', label: 'Mãe' },
                  { value: 'grandpa', label: 'Avô' },
                  { value: 'grandma', label: 'Avó' },
                  { value: 'brother', label: 'Irmão' },
                  { value: 'friend', label: 'Amigo(a)' },
                  { value: 'myself', label: 'Eu mesmo' },
                  { value: 'other', label: 'Outro' }
                ].map(opt => (
                  <button
                    key={opt.value}
                    type="button"
                    className={`option-btn ${
                      quizData.recipient === opt.value ? 'selected' : ''
                    }`}
                    onClick={() => handleOptionSelect('recipient', opt.value)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>

              {quizData.recipient === 'other' && (
                <div className="form-group extra-field">
                  <label className="form-label">
                    Qual o parentesco? <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-input"
                    placeholder="Ex: Tio, Namorada..."
                    value={quizData.recipientOther || ''}
                    onChange={(e) =>
                      handleOptionSelect('recipientOther', e.target.value)
                    }
                  />
                </div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                Nome da pessoa <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-input"
                id="personName"
                value={quizData.personName}
                onChange={handleInputChange}
              />
            </div>

            <div className="button-group-nav">
              <button className="btn btn-back" onClick={prevStep}>← Voltar</button>
              <button className="btn btn-next" onClick={nextStep}>Próximo →</button>
            </div>
          </div>
        )}

        {/* Passo 1: Evento */}
        {currentStep === 1 && quizData.typeGroup === 'evento' && (
          <div className="step-section active">
            <h2 className="step-title">Sobre o Evento</h2>
            <p className="step-description">
              Que tipo de evento essa música representa?
            </p>

            <div className="form-group">
              <label className="form-label">
                Tipo de evento <span className="required">*</span>
              </label>

              <div className="button-group">
                {[
                  { value: 'wedding', label: 'Casamento' },
                  { value: 'birthday', label: 'Aniversário' },
                  { value: 'corporate', label: 'Evento Corporativo' },
                  { value: 'graduation', label: 'Formatura' },
                  { value: 'religious', label: 'Evento Religioso' },
                  { value: 'other', label: 'Outro' }
                ].map(opt => (
                  <button
                    key={opt.value}
                    type="button"
                    className={`option-btn ${
                      quizData.eventType === opt.value ? 'selected' : ''
                    }`}
                    onClick={() => handleOptionSelect('eventType', opt.value)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>

              {/* Campo extra quando "Outro" for selecionado */}
              {quizData.eventType === 'other' && (
                <div className="form-group extra-field">
                  <label className="form-label">
                    Qual evento? <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-input"
                    placeholder="Ex: Chá de bebê, Bodas de Ouro..."
                    value={quizData.eventOther || ''}
                    onChange={(e) =>
                      handleOptionSelect('eventOther', e.target.value)
                    }
                  />
                </div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                Nomes dos envolvidos <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-input"
                id="eventNames"
                placeholder="Ex: João e Ana"
                value={quizData.eventNames}
                onChange={handleInputChange}
              />
            </div>

            <div className="button-group-nav">
              <button className="btn btn-back" onClick={prevStep}>← Voltar</button>
              <button className="btn btn-next" onClick={nextStep}> Próximo → </button>
            </div>
          </div>
        )}


        {/* Passo 2: Estilo e Voz */}
        {/*<div className={`step-section ${currentStep === 2 ? 'active' : ''}`}>
          <h2 className="step-title">Estilo e Preferências</h2>
          <p className="step-description">Como você imagina o som da música?</p>
          <div className="form-group">
            <label className="form-label">Estilo Musical <span className="required">*</span></label>
            <div className="button-group">
              {['romantic', 'rock', 'mpb', 'sertanejo', 'pop'].map(opt => (
                <button 
                  key={opt}
                  type="button" 
                  className={`option-btn ${quizData.style === opt ? 'selected' : ''}`}
                  onClick={() => handleOptionSelect('style', opt)}
                >
                  {opt.toUpperCase()}
                </button>
              ))}
            </div>
          </div>*/}

          {/* Passo 2: Estilo e Voz */}
          <div className={`step-section ${currentStep === 2 ? 'active' : ''}`}>
            <h2 className="step-title">Estilo e Preferências</h2>
            <p className="step-description">Como você imagina o som da música?</p>

            <div className="form-group">
              <label className="form-label">
                Estilo Musical <span className="required">*</span>
              </label>

              <div className="button-group">
                {[
                  { value: 'romantic', label: 'Romântico' },
                  { value: 'rock', label: 'Rock' },
                  { value: 'mpb', label: 'MPB' },
                  { value: 'sertanejo', label: 'Sertanejo' },
                  { value: 'pop', label: 'Pop' },
                  { value: 'other', label: 'Outro' }
                ].map(opt => (
                  <button
                    key={opt.value}
                    type="button"
                    className={`option-btn ${
                      quizData.style === opt.value ? 'selected' : ''
                    }`}
                    onClick={() => handleOptionSelect('style', opt.value)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>

              {/* Campo extra quando "Outro" for selecionado */}
              {quizData.style === 'other' && (
                <div className="form-group extra-field">
                  <label className="form-label">
                    Qual estilo? <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-input"
                    placeholder="Ex: Jazz, Lo-fi, Gospel, Eletrônica..."
                    value={quizData.styleOther || ''}
                    onChange={(e) =>
                      handleOptionSelect('styleOther', e.target.value)
                    }
                  />
                </div>
              )}
          </div>

          <div className="form-group">
            <label className="form-label">
              Preferência de Voz <span className="required">*</span>
            </label>

            <div className="button-group">
              {[
                { value: 'female', label: 'Feminina' },
                { value: 'male', label: 'Masculina' }
              ].map(opt => (
                <button
                  key={opt.value}
                  type="button"
                  className={`option-btn ${
                    quizData.voice === opt.value ? 'selected' : ''
                  }`}
                  onClick={() => handleOptionSelect('voice', opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          <div className="button-group-nav">
            <button type="button" className="btn btn-back" onClick={prevStep}>← Voltar</button>
            <button type="button" className="btn btn-next" onClick={nextStep}>Próximo →</button>
          </div>
        </div>

        {/* Passo 3: Qualidades */}
        <div className={`step-section ${currentStep === 3 ? 'active' : ''}`}>
          <h2 className="step-title">Qualidades e Características</h2>
          <p className="step-description">O que torna essa pessoa especial?</p>
          <div className="form-group">
            <label className="form-label">Descreva qualidades, apelidos ou jeitos únicos:</label>
            <textarea 
              className="form-textarea" 
              id="qualities" 
              placeholder="Ex: Ela tem um sorriso contagiante, adora café, é muito determinada..."
              maxLength="500"
              value={quizData.qualities}
              onChange={handleInputChange}
            ></textarea>
            <div className="char-counter"><span>{counters.qualities}</span>/500</div>
            <p className="hint-text">Esses detalhes ajudam a tornar a letra mais autêntica.</p>
          </div>
          <div className="button-group-nav">
            <button type="button" className="btn btn-back" onClick={prevStep}>← Voltar</button>
            <button type="button" className="btn btn-next" onClick={nextStep}>Próximo →</button>
          </div>
        </div>

        {/* Passo 4: Memórias */}
        <div className={`step-section ${currentStep === 4 ? 'active' : ''}`}>
          <h2 className="step-title">Histórias e Memórias</h2>
          <p className="step-description">Momentos marcantes que devem estar na música.</p>
          <div className="form-group">
            <label className="form-label">Conte uma história ou momento especial:</label>
            <textarea 
              className="form-textarea" 
              id="memories" 
              placeholder="Ex: Nossa primeira viagem juntos para a praia, o dia que nos conhecemos na faculdade..."
              maxLength="800"
              value={quizData.memories}
              onChange={handleInputChange}
            ></textarea>
            <div className="char-counter"><span>{counters.memories}</span>/800</div>
          </div>
          <div className="button-group-nav">
            <button type="button" className="btn btn-back" onClick={prevStep}>← Voltar</button>
            <button type="button" className="btn btn-next" onClick={nextStep}>Próximo →</button>
          </div>
        </div>

        {/* Passo 5: Contato e Pacote */}
        <div className={`step-section ${currentStep === 5 ? 'active' : ''}`}>
          <h2 className="step-title">Finalizando seu Pedido</h2>
          <p className="step-description">Quase lá! Só precisamos dos seus dados para entrega.</p>
          <div className="form-group">
            <label className="form-label">Seu Nome Completo <span className="required">*</span></label>
            <input 
              type="text" 
              className="form-input" 
              id="yourName" 
              placeholder="Como devemos te chamar?" 
              required
              value={quizData.yourName}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Seu Melhor E-mail <span className="required">*</span></label>
            <input 
              type="email" 
              className="form-input" 
              id="email" 
              placeholder="seu@email.com" 
              required
              value={quizData.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label className="form-label">WhatsApp/Telefone <span className="required">*</span></label>
            <input 
              type="tel" 
              className="form-input" 
              id="phone" 
              placeholder="(21) 98765-4321" 
              required
              value={quizData.phone}
              onChange={handleInputChange}
            />
          </div>
          <div className="button-group-nav">
            <button type="button" className="btn btn-back" onClick={prevStep}>← Voltar</button>
            <button 
            type="button" className="btn btn-finish" onClick={submitQuiz}>Ir para Checkout →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quiz;


{/* Pacotes */}
{/*<div className="form-group">
            <label className="form-label">Pacote <span className="required">*</span></label>
            <select 
              className="form-select" 
              id="package" 
              required
              value={quizData.package}
              onChange={handleInputChange}
            >
              <option value="">Selecione um pacote</option>
              <option value="essential">Essencial - R$ 99 (até 3 min)</option>
              <option value="professional">Profissional - R$ 199 (até 5 min) - Mais Popular</option>
              <option value="premium">Premium - R$ 399 (2 músicas, até 5 min cada)</option>
            </select>
          </div>*/}

{/* Passo 1: Destinatário */}
        {/*<div className={`step-section ${currentStep === 1 ? 'active' : ''}`}>
          <h2 className="step-title">Para quem é a música?</h2>
          <p className="step-description">Conte-nos quem será o homenageado.</p>
          <div className="form-group">
            <label className="form-label">A música é para: <span className="required">*</span></label>
            <div className="button-group">
              {['spouse', 'parent', 'child', 'friend', 'other'].map(opt => (
                <button 
                  key={opt}
                  type="button" 
                  className={`option-btn ${quizData.recipient === opt ? 'selected' : ''}`}
                  onClick={() => handleOptionSelect('recipient', opt)}
                >
                  {opt === 'spouse' ? 'Esposo(a)' : opt === 'parent' ? 'Pai/Mãe' : opt === 'child' ? 'Filho(a)' : opt === 'friend' ? 'Amigo(a)' : 'Outro'}
                </button>
              ))}
            </div>
          </div>*/}